import { ReactNode, useMemo } from "react";
import BooksScreenSmall from "static/images/AuthTestimonial/MarketFeature/BooksScreenSmall.svg";
import TaxScreenSmall from "static/images/AuthTestimonial/MarketFeature/TaxScreenSmall.svg";
import PinkStar from "static/images/PinkStar.svg";

export const MobileSigninAuthWrapper = ({
  children,
}: {
  children: ReactNode;
}) => {
  const isRandorNumberEven = useMemo(
    () => Math.floor((Math.random() * 10 + 1) % 2),
    []
  );

  const platformDetails = isRandorNumberEven
    ? {
        img: TaxScreenSmall,
        title: "Urgent filing detection with Inkle AI",
      }
    : {
        img: BooksScreenSmall,
        title: "Instant business insights with Inkle AI",
      };

  return (
    <div className="t-h-screen t-w-screen t-flex t-flex-col t-overflow-hidden t-relative t-bg-purple-100">
      <div className="t-mt-8 t-flex t-flex-col t-justify-center t-items-center">
        <div className="t-text-body-sm t-text-surface">Introducing</div>
        <div className="t-flex t-gap-1 t-items-center t-mb-3">
          <div className="t-text-subtext-sm signin-title">
            {platformDetails.title}
          </div>
          <img
            src={PinkStar}
            alt="PinkStar"
            className="t-flex-shrink-0 t-size-4"
          />
        </div>
        <img src={platformDetails.img} alt="" />
      </div>

      <div className="t-bg-surface t-rounded-[20px] t-rounded-b-none t-p-6 t-flex-1 t-overflow-auto t-border t-border-solid t-border-neutral-10 t-shadow-mobile-signin">
        {children}
      </div>
    </div>
  );
};
